/* TWO4ONE — theme.js
   Port of the approved prototype (scripts/app.js, "Het Huis") to Shopify: same components, same interaction logic.
   v1.1.0: option-based product variant state (round colour swatches, compact sizes, stock status, dynamic checkout lock).
   Data now comes from Liquid; this file binds behaviour: header state + mega menu + predictive search, drawers/scrim/sheet,
   Ajax cart (Cart API + Section Rendering API), wishlist (localStorage), connect module, collection index, collection filters
   (Search & Discovery via section rendering), product page (size → variant, add, sticky bar, size guide), lookbook markers,
   wishlist page. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var CFG = window.T4O || {};
  var R = CFG.routes || {};
  var S = CFG.strings || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); };
  var store = {
    get: function (k, d) { try { return JSON.parse(localStorage.getItem(k)) || d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } }
  };
  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = matchMedia('(hover: hover)').matches;
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10.3A4.2 4.2 0 0 1 12 7.6a4.2 4.2 0 0 1 7.5 2.6c0 5.7-7.5 10.3-7.5 10.3z"/></svg>';

  /* ---------- money (mirrors shop.money_format) ---------- */
  function group(intStr, sep) { return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function money(cents) {
    var f = CFG.moneyFormat || '€ {{amount_with_comma_separator}}';
    var v = (Number(cents) || 0) / 100;
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/); var key = m ? m[1] : 'amount';
    var parts = v.toFixed(2).split('.'); var out;
    switch (key) {
      case 'amount_no_decimals': out = group(String(Math.round(v)), ','); break;
      case 'amount_with_comma_separator': out = group(parts[0], '.') + ',' + parts[1]; break;
      case 'amount_no_decimals_with_comma_separator': out = group(String(Math.round(v)), '.'); break;
      case 'amount_with_apostrophe_separator': out = group(parts[0], "'") + '.' + parts[1]; break;
      case 'amount_with_space_separator': out = group(parts[0], ' ') + ',' + parts[1]; break;
      case 'amount_no_decimals_with_space_separator': out = group(String(Math.round(v)), ' '); break;
      default: out = group(parts[0], ',') + '.' + parts[1];
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]+>/g, '');
  }
  function priceHtml(cents, compare) {
    if (compare && compare > cents) return '<span class="price"><s>' + money(compare) + '</s><span class="is-sale">' + money(cents) + '</span></span>';
    return '<span class="price">' + money(cents) + '</span>';
  }

  /* ---------- layers (drawers / sheet / scrim) ---------- */
  var lastFocus = null;
  function openLayer(id) {
    var el = document.getElementById(id); if (!el) return; closeLayers(true); closeMega();
    lastFocus = document.activeElement; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    var sc = $('.scrim'); if (sc) sc.classList.add('is-open'); document.body.classList.add('no-scroll');
    $$('[data-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var f = $('button, a, input', el); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeLayers(silent) {
    $$('.drawer.is-open, .sheet.is-open').forEach(function (el) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); });
    $$('[data-open][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var sc = $('.scrim'); if (sc) sc.classList.remove('is-open'); document.body.classList.remove('no-scroll');
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- header: mega menu, search line, logo state ---------- */
  var hdr = $('#hdr'), mega = $('#mega'), megaT;
  var triggers = $$('[data-mega]');
  function openMega(t) { if (!mega) return; clearTimeout(megaT); mega.classList.add('is-open'); hdr.classList.add('is-open'); triggers.forEach(function (x) { x.setAttribute('aria-expanded', String(x === t)); }); closeSearch(); }
  function closeMega() { clearTimeout(megaT); if (!mega) return; mega.classList.remove('is-open'); hdr.classList.remove('is-open'); triggers.forEach(function (x) { x.setAttribute('aria-expanded', 'false'); }); }
  if (hdr) {
    triggers.forEach(function (t) {
      t.addEventListener('mouseenter', function () { if (canHover) { clearTimeout(megaT); megaT = setTimeout(function () { openMega(t); }, 120); } });
      t.addEventListener('focus', function () { openMega(t); });
      t.addEventListener('click', function (e) { if (!canHover) { e.preventDefault(); mega && mega.classList.contains('is-open') ? closeMega() : openMega(t); } });
    });
    $$('.nav__link:not([data-mega])').forEach(function (a) { a.addEventListener('mouseenter', function () { clearTimeout(megaT); megaT = setTimeout(closeMega, 120); }); });
    hdr.addEventListener('mouseleave', function () { clearTimeout(megaT); megaT = setTimeout(closeMega, 160); });
    if (mega) mega.addEventListener('mouseenter', function () { clearTimeout(megaT); });
    hdr.addEventListener('focusout', function (e) { if (!hdr.contains(e.relatedTarget)) closeMega(); });
    if (!canHover) document.addEventListener('click', function (e) { if (mega && !hdr.contains(e.target)) closeMega(); });
  }

  var search = $('#search'), sBtn = $('[data-search]');
  function closeSearch() { if (!search) return; search.classList.remove('is-open'); hdr.classList.remove('is-forced'); if (sBtn) sBtn.setAttribute('aria-expanded', 'false'); }
  if (sBtn && search) sBtn.addEventListener('click', function () { var on = search.classList.toggle('is-open'); hdr.classList.toggle('is-forced', on); sBtn.setAttribute('aria-expanded', on); closeMega(); if (on) { var q = $('#q'); if (q) q.focus(); } });
  var q = $('[data-predictive]'), qT, qCtl;
  function imgSize(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  if (q) q.addEventListener('input', function () {
    var v = q.value.trim(); var res = $('.search__res'); if (!res) return;
    clearTimeout(qT); if (v.length < 2) { res.innerHTML = ''; return; }
    qT = setTimeout(function () {
      if (qCtl) qCtl.abort(); qCtl = new AbortController();
      var url = (R.predictiveSearch || '/search/suggest') + '?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(url, { signal: qCtl.signal, headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) {
        var list = (d.resources && d.resources.results && d.resources.results.products) || [];
        res.innerHTML = list.length ? list.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var cents = Math.round(parseFloat(p.price) * 100);
          return '<a href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(imgSize(img, 120)) + '" alt="" loading="lazy">' : '') + '<span>' + esc(p.title) + '</span><span class="muted">' + money(cents) + '</span></a>';
        }).join('') : '<p class="muted">' + esc(S.nothingFound || 'Niks gevonden.') + '</p>';
      }).catch(function () { /* aborted */ });
    }, 180);
  });

  (function logoWatch() {
    if (!hdr) return; var secs = $$('[data-logo]'); if (!secs.length) return; var io; var seen = new Set();
    var apply = function () { var best = null, top = -Infinity; seen.forEach(function (s) { var t = s.getBoundingClientRect().top; if (t > top) { top = t; best = s; } }); hdr.classList.toggle('is-dark', !!best && best.dataset.logo !== 'light'); };
    var setup = function () { if (io) io.disconnect(); seen.clear(); secs = $$('[data-logo]'); io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? seen.add(e.target) : seen.delete(e.target); }); apply(); }, { rootMargin: '0px 0px -' + Math.max(0, innerHeight - hdr.offsetHeight - 1) + 'px 0px', threshold: 0 }); secs.forEach(function (s) { io.observe(s); }); };
    setup(); var rt; addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(setup, 150); });
    document.addEventListener('shopify:section:load', function () { setTimeout(setup, 50); });
  })();

  /* ---------- announcement rotation ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var msgs = $$('.ann__msg', bar); if (msgs.length < 2 || reduced) return; var i = 0;
    setInterval(function () { msgs[i].hidden = true; i = (i + 1) % msgs.length; msgs[i].hidden = false; }, (parseInt(bar.dataset.interval, 10) || 6) * 1000);
  });

  /* ---------- cart (Ajax + Section Rendering API) ---------- */
  function counts() {
    var aside = $('#cart'); var n = aside ? parseInt(aside.dataset.count, 10) || 0 : 0;
    $$('.js-cart-count').forEach(function (e) { e.textContent = n || ''; });
    $$('.js-wish-count').forEach(function (e) { e.textContent = wish.items.length || ''; });
  }
  var cart = {
    busy: false,
    request: function (url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Cart error'); return j; }); });
    },
    add: function (variantId, qty) {
      if (!variantId) return Promise.reject(new Error('no variant'));
      return cart.request((R.cartAdd || '/cart/add') + '.js', { items: [{ id: Number(variantId), quantity: qty || 1 }] })
        .then(cart.refresh).then(function () { openLayer('cart'); });
    },
    change: function (line, quantity) {
      return cart.request((R.cartChange || '/cart/change') + '.js', { line: Number(line), quantity: Number(quantity) }).then(cart.refresh);
    },
    refresh: function () {
      var root = R.root || '/';
      return fetch(root + (root.indexOf('?') > -1 ? '&' : '?') + 'sections=cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var html = d['cart-drawer']; if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#cart'), cur = $('#cart');
          if (fresh && cur) { cur.innerHTML = fresh.innerHTML; cur.dataset.count = fresh.dataset.count || '0'; }
          counts();
          document.dispatchEvent(new CustomEvent('t4o:cart', { detail: { count: cur ? cur.dataset.count : 0 } }));
        });
    }
  };

  /* ---------- wishlist (localStorage, no app) ---------- */
  var wish = {
    items: store.get('t4o-wish', []),
    has: function (h) { return this.items.indexOf(h) > -1; },
    toggle: function (h) {
      this.has(h) ? this.items.splice(this.items.indexOf(h), 1) : this.items.push(h);
      store.set('t4o-wish', this.items); syncWish(); counts();
    }
  };
  function syncWish(root) {
    $$('.card__wish, [data-wish]', root).forEach(function (b) {
      var h = b.dataset.handle || b.dataset.wish; var on = wish.has(h);
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on));
    });
  }

  /* ---------- global click delegation ---------- */
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMega(); closeSearch(); closeLayers(); } });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open], [data-close], .card__wish, [data-wish], .card__sizes button, [data-delta], [data-remove], .mnav__top[aria-expanded], [data-look], [data-modal], [data-modal-close]');
    if (!t) return;
    if (t.matches('[data-open]')) { e.preventDefault(); openLayer(t.dataset.open); }
    else if (t.matches('[data-close]')) { if (t.tagName !== 'A') e.preventDefault(); closeLayers(); }
    else if (t.matches('.card__wish')) { wish.toggle(t.dataset.handle); }
    else if (t.matches('[data-wish]')) { wish.toggle(t.dataset.wish); }
    else if (t.matches('.card__sizes button')) {
      if (t.getAttribute('aria-disabled') === 'true') return;
      var c = t.closest('.card'); var m = $('.card__msg', c);
      t.classList.add('is-loading');
      cart.add(t.dataset.variant).then(function () { if (m) { m.textContent = (S.added || 'Toegevoegd — maat') + ' ' + t.dataset.size; setTimeout(function () { m.textContent = ''; }, 2400); } })
        .catch(function (err) { if (m) m.textContent = err.message; }).then(function () { t.classList.remove('is-loading'); });
    }
    else if (t.matches('[data-delta], [data-remove]')) {
      var item = t.closest('.cart__item'); if (!item || cart.busy) return;
      var line = item.dataset.line; var cur = parseInt($('.qty span', item).textContent, 10) || 0;
      var next = t.matches('[data-remove]') ? 0 : Math.max(0, cur + parseInt(t.dataset.delta, 10));
      cart.busy = true; item.style.opacity = '.5';
      cart.change(line, next).then(function () { if (t.closest('[data-cart-page]')) location.reload(); }).catch(function () { item.style.opacity = ''; }).then(function () { cart.busy = false; });
    }
    else if (t.matches('.mnav__top')) { var on = t.getAttribute('aria-expanded') !== 'true'; t.setAttribute('aria-expanded', on); t.nextElementSibling.classList.toggle('is-open', on); }
    else if (t.matches('[data-look]')) {
      var side = t.closest('.look__side'); var list = side && $('[data-look-list]', side);
      var st = $('#sheet-title'), sl = $('#sheet-list'); if (!list || !st || !sl) return;
      st.textContent = t.dataset.lookTitle || st.textContent; sl.innerHTML = list.innerHTML; openLayer('sheet');
    }
    else if (t.matches('[data-modal]')) { var dlg = document.getElementById(t.dataset.modal); if (dlg && dlg.showModal) dlg.showModal(); }
    else if (t.matches('[data-modal-close]')) { var d2 = t.closest('dialog'); if (d2) d2.close(); }
  });
  $$('dialog.modal').forEach(function (dlg) { dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); }); });
  if (location.hash === '#maattabel') { var mt = $('#maattabel'); if (mt && mt.showModal) mt.showModal(); }

  /* ---------- LET'S CONNECT → "2GETHER, 4EVER, 1" ---------- */
  function initConnect(el) {
    if (el.dataset.ready) return; el.dataset.ready = '1';
    var w = $('.connect__word', el); var words = (el.dataset.words || '2gether.|4ever.|1.').split('|').filter(Boolean); var wi = 0;
    if (w && words.length > 1 && !reduced) setInterval(function () { w.classList.add('is-fading'); setTimeout(function () { wi = (wi + 1) % words.length; w.textContent = words[wi]; w.classList.remove('is-fading'); }, 360); }, 3000);
    var rail = $('.connect__rail', el); if (!rail || !rail.firstElementChild) return; var paused = false, vis = false;
    ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (ev) { rail.addEventListener(ev, function () { paused = true; }, { passive: true }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { rail.addEventListener(ev, function () { if (canHover) paused = false; }); });
    new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }, { threshold: .3 }).observe(rail);
    if (!reduced) setInterval(function () { if (paused || !vis) return; var step = rail.firstElementChild.getBoundingClientRect().width + 16; var max = rail.scrollWidth - rail.clientWidth; if (rail.scrollLeft >= max - 4) rail.scrollTo({ left: 0, behavior: 'smooth' }); else rail.scrollBy({ left: step, behavior: 'smooth' }); }, 3800);
    var ok = $('.connect__ok', el); if (ok && location.search.indexOf('customer_posted=true') > -1) { setTimeout(function () { ok.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' }); }, 100); }
  }

  /* ---------- HOME: collections index ---------- */
  function initCidx(cidx) {
    if (cidx.dataset.ready) return; cidx.dataset.ready = '1';
    var panel = $('.cidx__panel', cidx); if (!panel) return; var imgs = $$('img', panel), lab = $('.label', panel);
    $$('.cidx__row', cidx).forEach(function (r) { ['mouseenter', 'focus'].forEach(function (ev) { r.addEventListener(ev, function () { var i = +r.dataset.i; imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); }); if (lab) lab.textContent = r.dataset.title || ''; }); }); });
  }

  /* ---------- COLLECTION: filters, sort, load more (Section Rendering API) ---------- */
  function initCollection(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var sectionId = root.dataset.sectionId; var base = root.dataset.url || location.pathname;
    var grid = $('[data-grid]', root); var busy = false;
    function urlFromForm() {
      var form = $('#filters-form'); var u = new URL(base, location.origin);
      if (form) { var fd = new FormData(form); fd.forEach(function (v, k) { if (v !== '') u.searchParams.append(k, v); }); }
      var sort = $('[data-sort]', root); if (sort && !u.searchParams.has('sort_by')) u.searchParams.set('sort_by', sort.value);
      return u;
    }
    function apply(url, append) {
      if (busy) return; busy = true; root.classList.add('is-loading');
      var u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
      fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.querySelector('[data-grid]');
        if (append && ng && grid) { Array.prototype.slice.call(ng.children).forEach(function (c) { grid.appendChild(c); }); }
        else if (ng && grid) grid.innerHTML = ng.innerHTML;
        ['[data-chips]', '[data-count]', '[data-more]', '[data-empty]'].forEach(function (sel) { var a = $(sel, root.parentElement || document), b = doc.querySelector(sel); if (a && b) { a.innerHTML = b.innerHTML; a.hidden = b.hidden; } });
        var ff = $('#filters-form'), nf = doc.querySelector('#filters-form'); if (ff && nf) ff.innerHTML = nf.innerHTML;
        var fb = $('[data-open="filters"]', root), nfb = doc.querySelector('[data-open="filters"]'); if (fb && nfb) fb.innerHTML = nfb.innerHTML;
        if (append) { var mc = $('[data-more-count]', root), nmc = doc.querySelector('[data-more-count]'); if (mc && nmc && grid) { var total = nmc.textContent.trim().split(' ').pop(); mc.textContent = grid.children.length + ' ' + (S.of || 'van') + ' ' + total; } }
        u.searchParams.delete('section_id'); if (!append) history.replaceState(null, '', u.pathname + (u.search || ''));
        syncWish(root);
      }).catch(function () { location.href = url; }).then(function () { busy = false; root.classList.remove('is-loading'); });
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest('#filters-form')) { var u = urlFromForm(); var sort = $('[data-sort]', root); if (sort) u.searchParams.set('sort_by', sort.value); apply(u.toString(), false); }
      else if (e.target.matches('[data-sort]') && root.contains(e.target)) { var u2 = urlFromForm(); u2.searchParams.set('sort_by', e.target.value); apply(u2.toString(), false); }
    });
    document.addEventListener('click', function (e) {
      var lm = e.target.closest('[data-load-more]'); if (lm && root.contains(lm)) { e.preventDefault(); lm.classList.add('is-loading'); apply(lm.getAttribute('href'), true); return; }
      var chip = e.target.closest('[data-chips] .chip, [data-empty] a'); if (chip && root.contains(chip)) { e.preventDefault(); apply(chip.getAttribute('href'), false); }
    });
  }

  /* ---------- PRODUCT (v1.1.0: option-based variant state — colour swatches + compact size buttons) ---------- */
  function initProduct(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var variants = [], st = { optionNames: [], selected: [], colorIndex: -1, onlyDefault: false };
    try { variants = JSON.parse(($('[data-variants]', root) || {}).textContent || '[]'); } catch (e) { /* noop */ }
    try { st = Object.assign(st, JSON.parse(($('[data-product-state]', root) || {}).textContent || '{}')); } catch (e) { /* noop */ }
    var nOpt = st.optionNames.length;
    var selected = st.onlyDefault ? [] : (st.selected || []).slice(0, nOpt).map(function (v) { return v || null; });
    var touched = false;

    var gal = $('[data-gallery]', root), cnt = $('#gal-count', root);
    if (gal && cnt) { var n = gal.children.length; gal.addEventListener('scroll', function () { cnt.textContent = (Math.round(gal.scrollLeft / gal.clientWidth) + 1) + '/' + n; }, { passive: true }); }

    var form = $('[data-product-form]', root), idInput = $('[data-variant-id]', root), msg = $('[data-msg]', root), add = $('[data-add]', root);
    var bar = $('[data-stickybar]'), barAdd = $('[data-bar-add]'), barPrice = $('[data-bar-price]'), price = $('[data-price]', root);
    var stock = $('[data-stock]', root), stockText = $('[data-stock-text]', root), pay = $('[data-pay]', root);
    var groups = $$('[data-option]', root);
    var soldoutProduct = root.dataset.state === 'soldout';

    function complete() { return st.onlyDefault || (nOpt > 0 && selected.every(function (v) { return !!v; })); }
    function current() {
      if (st.onlyDefault) return variants[0] || null;
      if (!complete()) return null;
      return variants.filter(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); })[0] || null;
    }
    function valueAvailable(idx, value) {
      return variants.some(function (v) { return v.available && v.options[idx] === value && selected.every(function (sv, i) { return i === idx || !sv || v.options[i] === sv; }); });
    }
    function setStock(avail) { if (!stock) return; stock.classList.toggle('stock--out', !avail); if (stockText) stockText.textContent = avail ? (S.inStock || 'Op voorraad') : (S.soldOut || 'Uitverkocht'); }
    function setPrice(v) { if (!v) return; var h = priceHtml(v.price, v.compare_at_price); if (price) price.innerHTML = h; if (barPrice) barPrice.innerHTML = h; }
    function showMedia(v) {
      if (!gal || !v || !v.featured_media) return;
      var fig = gal.querySelector('[data-media-id="' + v.featured_media.id + '"]'); if (!fig) return;
      if (matchMedia('(min-width: 1024px)').matches) { var r = fig.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) fig.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }); }
      else gal.scrollTo({ left: fig.offsetLeft - gal.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
    }
    function refresh() {
      groups.forEach(function (g) {
        var idx = +g.dataset.optionIndex;
        $$('[data-value]', g).forEach(function (b) {
          var val = b.dataset.value, on = selected[idx] === val;
          b.setAttribute('aria-checked', String(on)); b.classList.toggle('is-selected', on);
          if (valueAvailable(idx, val)) b.removeAttribute('aria-disabled'); else b.setAttribute('aria-disabled', 'true');
        });
        var lbl = $('[data-option-value]', g); if (lbl && selected[idx]) lbl.textContent = selected[idx];
      });
      var v = current();
      if (v) {
        if (idInput) idInput.value = v.id;
        setPrice(v); setStock(v.available);
        if (add) { add.disabled = !v.available; add.textContent = v.available ? (S.addToCart || add.textContent) : (S.soldOut || 'Uitverkocht'); }
        if (barAdd) { barAdd.disabled = !v.available; barAdd.textContent = v.available ? (S.addShort || 'Toevoegen') : (S.soldOut || 'Uitverkocht'); }
        if (pay) pay.classList.toggle('is-locked', !v.available);
        if (msg && !st.onlyDefault) msg.textContent = v.title === 'Default Title' ? '' : v.title;
        if (touched) {
          showMedia(v);
          if (history.replaceState && !st.onlyDefault) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.pathname + u.search + u.hash); }
        }
      } else {
        setStock(!soldoutProduct);
        if (pay) pay.classList.add('is-locked');
        if (add) add.disabled = soldoutProduct;
      }
    }
    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-value]'); if (!b || b.getAttribute('aria-disabled') === 'true') return;
        var idx = +g.dataset.optionIndex; selected[idx] = b.dataset.value; touched = true;
        var grp = $('.sizes, .sw', g); if (grp) grp.classList.remove('is-alert');
        refresh();
      });
      g.addEventListener('keydown', function (e) {
        if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
        var items = $$('[data-value]:not([aria-disabled="true"])', g); var i = items.indexOf(document.activeElement); if (i < 0) return;
        e.preventDefault(); var next = items[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : items.length - 1)) % items.length]; next.focus(); next.click();
      });
    });
    function firstIncomplete() { return groups.filter(function (g) { return !selected[+g.dataset.optionIndex]; })[0]; }
    function prompt() {
      var g = firstIncomplete(); var name = g ? (g.dataset.optionName || S.size || '') : '';
      if (msg) msg.textContent = /maat|size/i.test(name) ? (S.chooseSize || 'Kies eerst een maat') : (S.chooseOption || 'Kies eerst een {{ option }}').replace('{{ option }}', name.toLowerCase());
      if (!g) return;
      var grp = $('.sizes, .sw', g); if (!grp) return;
      grp.classList.add('is-shake', 'is-alert'); setTimeout(function () { grp.classList.remove('is-shake'); }, 450);
      grp.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
      var f = $('[data-value]:not([aria-disabled="true"])', grp); if (f) f.focus({ preventScroll: true });
    }
    function tryAdd() {
      if (soldoutProduct) return;
      var v = current();
      if (!v) { prompt(); return; }
      if (!v.available) { if (msg) msg.textContent = S.soldOut || 'Uitverkocht'; return; }
      if (add) add.classList.add('is-loading');
      cart.add(v.id).catch(function (err) { if (msg) msg.textContent = err.message; }).then(function () { if (add) add.classList.remove('is-loading'); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); tryAdd(); });
    if (barAdd) barAdd.addEventListener('click', tryAdd);
    if (pay) pay.addEventListener('click', function (e) { if (pay.classList.contains('is-locked')) { e.preventDefault(); e.stopPropagation(); if (!soldoutProduct) prompt(); } }, true);
    if (add && bar && !soldoutProduct) new IntersectionObserver(function (es) { bar.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(add);
    refresh();
  }

  /* ---------- LOOKBOOK markers ---------- */
  function initMarkers(root) {
    $$('.marker', root).forEach(function (m) { if (m.dataset.ready) return; m.dataset.ready = '1'; var a = m.firstElementChild; a.addEventListener('focus', function () { m.classList.add('is-open'); }); a.addEventListener('blur', function () { setTimeout(function () { if (!m.contains(document.activeElement)) m.classList.remove('is-open'); }, 10); }); });
  }

  /* ---------- WISHLIST page (cards rendered from /products/<handle>.js) ---------- */
  function cardFromJson(p) {
    var img1 = p.images && p.images[0] ? imgSize(p.images[0], 800) : ''; var img2 = p.images && p.images[1] ? imgSize(p.images[1], 800) : '';
    var sold = !p.variants.some(function (v) { return v.available; });
    var v0 = p.variants[0] || {}; var sizesHtml = p.variants.map(function (v) { return '<button type="button" data-variant="' + v.id + '" data-size="' + esc(v.title) + '"' + (v.available ? '' : ' aria-disabled="true"') + '>' + esc(v.title) + '</button>'; }).join('');
    return '<article class="card' + (sold ? ' card--soldout' : '') + '" data-handle="' + esc(p.handle) + '"><div class="card__media"><a href="/products/' + esc(p.handle) + '" aria-label="' + esc(p.title) + '">' + (img1 ? '<img src="' + esc(img1) + '" alt="' + esc(p.title) + '" loading="lazy" width="1600" height="1600">' : '') + (img2 ? '<img src="' + esc(img2) + '" alt="" loading="lazy" width="1600" height="1600">' : '') + '</a>' +
      (sold ? '<span class="pill card__pill pill--soldout">' + esc(S.soldOut || 'Uitverkocht') + '</span>' : '') +
      '<button type="button" class="card__wish is-on" data-handle="' + esc(p.handle) + '" aria-pressed="true" aria-label="' + esc(S.save || 'Bewaar') + ' ' + esc(p.title) + '">' + HEART + '</button>' +
      (!sold ? '<div class="card__qp"><span class="label">Snel kiezen</span><div class="card__sizes">' + sizesHtml + '</div></div>' : '') + '</div>' +
      '<div class="card__body"><span class="label">' + esc(p.type || '') + '</span><div class="card__row"><a class="card__name" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' + priceHtml(v0.price, v0.compare_at_price) + '</div><span class="card__msg" aria-live="polite"></span></div></article>';
  }
  function initWishlistPage(root) {
    var grid = $('[data-wish-grid]', root), empty = $('[data-wish-empty]', root), lab = $('[data-wish-count-label]');
    function render() {
      var hs = wish.items.slice(); if (lab) lab.textContent = hs.length + ' ' + (hs.length === 1 ? (S.item || 'item') : (S.items || 'items'));
      if (!hs.length) { grid.innerHTML = ''; empty.hidden = false; return; } empty.hidden = true;
      Promise.all(hs.map(function (h) { return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
        .then(function (ps) { grid.innerHTML = ps.filter(Boolean).map(cardFromJson).join(''); });
    }
    render();
    root.addEventListener('click', function (e) { if (e.target.closest('.card__wish')) setTimeout(render, 50); });
  }

  /* ---------- init ---------- */
  function init(root) {
    root = root || document;
    $$('[data-connect]', root).forEach(initConnect);
    $$('[data-cidx]', root).forEach(initCidx);
    $$('[data-collection]', root).forEach(initCollection);
    $$('[data-product]', root).forEach(initProduct);
    initMarkers(root);
    $$('[data-wishlist-page]', root).forEach(initWishlistPage);
    syncWish(root);
  }
  init(); counts();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector('#cart')) openLayer('cart'); });
  document.addEventListener('shopify:section:deselect', function () { closeLayers(true); });
})();
